import { AxiosError } from "axios";
import { NotificationMessage } from "./Types";

const ErrorHandler = (
  error: AxiosError,
  setNotificationMessage: (notificationMessage: NotificationMessage) => void
) => {
  if (error.code === "ERR_NETWORK") setNotificationMessage({ class: "danger", message: error.message });
  else {
    if (error.response?.status === 404) setNotificationMessage({ class: "danger", message: error.response.statusText });
    if (error.response?.status === 401) setNotificationMessage({ class: "danger", message: "Please login" });
  }
};

export default ErrorHandler;
